export function addSerialId<T = { [key: string]: any }>(data: T[]) {
    return data.map((i, index) => ({...i, serial: index+1}))
};